var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"GoToButton",class:_vm.color ? _vm.color : '',staticStyle:{"text-transform":"uppercase"},attrs:{"rounded":"","x-small":"","text":"","min-width":_vm.$props.min_width,"to":_vm.to ? _vm.to : ''}},[_c('div',{staticClass:"white--text text-12 font-weight-light",domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }